import clsx from 'clsx'
import React, { Dispatch, FC, SetStateAction } from 'react'

import { BookingSections } from './PotentialBooking'

type Props = {
  selectedTab: BookingSections
  setSelectedTab: Dispatch<SetStateAction<BookingSections>>
}
export const BookingSectionTabs: FC<Props> = (props) => {
  return (
    <div className="mb-4 flex flex-row border-b border-secondary lg:hidden">
      {Object.values(BookingSections).map((tab, i) => (
        <Tab key={i} tabName={tab} {...props} />
      ))}
    </div>
  )
}

interface TabProps {
  selectedTab: Props['selectedTab']
  setSelectedTab: Props['setSelectedTab']
  tabName: BookingSections
}
const Tab = ({ tabName, selectedTab, setSelectedTab }: TabProps) => {
  const handleClick = () => setSelectedTab(tabName)
  const isSelected = tabName === selectedTab
  return (
    <button
      className={clsx(
        'border-transparent first-of-type:ml-6 mr-8 pb-1 font-bold border-b-2',
        isSelected && 'text-green-300 border-green-300',
      )}
      onClick={handleClick}
    >
      {tabName}
    </button>
  )
}
